var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-page-content-wrapper", attrs: { id: "roles" } },
    [
      _vm.isEdit
        ? [
            _c("role-edit", {
              ref: "roleEditComponent",
              attrs: { roleId: _vm.roleId },
              on: { saved: _vm.onRoleSaved, cancelled: _vm.goBackToRoles },
            }),
          ]
        : [
            _c("div", { staticClass: "roles-page" }, [
              _c(
                "div",
                { staticClass: "roles-header" },
                [
                  _c("a-input-search", {
                    staticClass: "search-input roles-search",
                    attrs: { placeholder: _vm.$t("message.search") },
                    on: { search: _vm.onSearch },
                    model: {
                      value: _vm.searchText,
                      callback: function ($$v) {
                        _vm.searchText = $$v
                      },
                      expression: "searchText",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "roles-header__right" },
                    [
                      _c(
                        "SupsisButton",
                        {
                          attrs: { small: "", ghost: "" },
                          on: { click: _vm.collapseAllRoles },
                        },
                        [
                          _c("md-icon", [_vm._v("unfold_less")]),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("message.collapseAll")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          attrs: { small: "", ghost: "" },
                          on: { click: _vm.expandAllRoles },
                        },
                        [
                          _c("md-icon", [_vm._v("unfold_more")]),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("message.expandAll")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          attrs: { ghost: "" },
                          on: { click: _vm.createNewRole },
                        },
                        [
                          _c("md-icon", [_vm._v("add")]),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("message.createRole")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "role-groups" },
                _vm._l(_vm.roleGroups, function (usersInGroup, groupKey) {
                  return _c(
                    "div",
                    {
                      key: groupKey,
                      staticClass: "role-card",
                      class: {
                        "role-card--no-role": groupKey === _vm.noRoleKey,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "role-card__header",
                          on: {
                            click: function ($event) {
                              return _vm.toggleRoleGroup(groupKey)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "role-card__title-row" },
                            [
                              _c(
                                "md-icon",
                                { staticClass: "role-card__toggle" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.expandedRoleGroups.has(groupKey)
                                        ? "expand_more"
                                        : "chevron_right"
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "role-card__name" }, [
                                _vm._v(
                                  _vm._s(_vm.getRoleGroupDisplayName(groupKey))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "role-card__count" }, [
                                _vm._v(_vm._s(usersInGroup.length)),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.getRoleByKey(groupKey)
                            ? _c(
                                "div",
                                {
                                  staticClass: "role-card__actions",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                },
                                [
                                  _vm.checkPermission(
                                    _vm.PERMISSION_TYPES["role.update"].tr.name
                                  )
                                    ? _c(
                                        "a-button",
                                        {
                                          staticClass: "action-btn",
                                          attrs: {
                                            type: "link",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.editRole(
                                                _vm.getRoleByKey(groupKey)
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("edit")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.checkPermission(
                                    _vm.PERMISSION_TYPES["role.delete"].tr.name
                                  )
                                    ? _c(
                                        "a-button",
                                        {
                                          staticClass:
                                            "action-btn action-btn--danger",
                                          attrs: {
                                            type: "link",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.remove(
                                                _vm.getRoleByKey(groupKey)._id
                                              )
                                            },
                                          },
                                        },
                                        [_c("ActionDelete")],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.expandedRoleGroups.has(groupKey),
                              expression: "expandedRoleGroups.has(groupKey)",
                            },
                          ],
                          staticClass: "role-card__body",
                        },
                        [
                          _vm.canUpdateUser && groupKey !== _vm.noRoleKey
                            ? _c(
                                "div",
                                { staticClass: "role-card__user-actions" },
                                [
                                  _c(
                                    "SupsisButton",
                                    {
                                      attrs: { xsmall: "", ghost: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openAddUserModal(groupKey)
                                        },
                                      },
                                    },
                                    [
                                      _c("md-icon", [_vm._v("person_add")]),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t("message.addUserToRole")
                                          ) +
                                          "\n                            "
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.getRoleGroupUsers(groupKey).length > 0 &&
                                  !_vm.isAllSelectedInRoleGroup(groupKey)
                                    ? _c(
                                        "SupsisButton",
                                        {
                                          attrs: { xsmall: "", ghost: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectAllInRoleGroup(
                                                groupKey
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("md-icon", [_vm._v("select_all")]),
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$t("message.selectAll")
                                              ) +
                                              "\n                            "
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.selectedUserIdsInRoleGroup(groupKey)
                                    .length > 0
                                    ? _c(
                                        "SupsisButton",
                                        {
                                          attrs: { xsmall: "", ghost: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deselectAllInRoleGroup(
                                                groupKey
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("md-icon", [_vm._v("deselect")]),
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$t("message.deselectAll")
                                              ) +
                                              "\n                            "
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.selectedUserIdsInRoleGroup(groupKey)
                                    .length > 0
                                    ? _c(
                                        "a-dropdown",
                                        { attrs: { trigger: ["click"] } },
                                        [
                                          _c(
                                            "SupsisButton",
                                            {
                                              attrs: { xsmall: "", ghost: "" },
                                            },
                                            [
                                              _c("md-icon", [
                                                _vm._v("drive_file_move"),
                                              ]),
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$t("message.moveToRole")
                                                  ) +
                                                  " (" +
                                                  _vm._s(
                                                    _vm.selectedUserIdsInRoleGroup(
                                                      groupKey
                                                    ).length
                                                  ) +
                                                  ")\n                                "
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a-menu",
                                            {
                                              attrs: { slot: "overlay" },
                                              on: {
                                                click: function (ref) {
                                                  var key = ref.key

                                                  return _vm.moveUsersToRoleDirectly(
                                                    groupKey,
                                                    key
                                                  )
                                                },
                                              },
                                              slot: "overlay",
                                            },
                                            _vm._l(
                                              _vm.getOtherRoles(groupKey),
                                              function (r) {
                                                return _c(
                                                  "a-menu-item",
                                                  { key: r._id },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(r.name) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "role-card__user-list" },
                            [
                              _vm._l(usersInGroup, function (user) {
                                return _c(
                                  "div",
                                  {
                                    key: user._id,
                                    staticClass: "role-user-item",
                                    class: {
                                      selected: _vm.isUserSelectedInRole(
                                        user._id
                                      ),
                                    },
                                  },
                                  [
                                    _vm.canUpdateUser &&
                                    groupKey !== _vm.noRoleKey
                                      ? _c("a-checkbox", {
                                          attrs: {
                                            checked: _vm.isUserSelectedInRole(
                                              user._id
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.toggleRoleUserSelection(
                                                user._id
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("AgentAvatar", {
                                      attrs: {
                                        userID: user._id,
                                        size: 32,
                                        isNamed: false,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "role-user-item__name" },
                                      [_vm._v(_vm._s(user.name || user.email))]
                                    ),
                                    _vm._v(" "),
                                    _vm.canUpdateUser &&
                                    groupKey !== _vm.noRoleKey &&
                                    _vm.getRoleByKey(groupKey)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "role-user-item__actions",
                                          },
                                          [
                                            _c(
                                              "a-dropdown",
                                              { attrs: { trigger: ["click"] } },
                                              [
                                                _c(
                                                  "a-button",
                                                  {
                                                    attrs: {
                                                      type: "link",
                                                      size: "small",
                                                    },
                                                  },
                                                  [
                                                    _c("md-icon", [
                                                      _vm._v("more_vert"),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-menu",
                                                  {
                                                    attrs: { slot: "overlay" },
                                                    slot: "overlay",
                                                  },
                                                  [
                                                    _c(
                                                      "a-menu-item",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.openRemoveUserModal(
                                                              user,
                                                              _vm.getRoleByKey(
                                                                groupKey
                                                              )._id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("md-icon", [
                                                          _vm._v(
                                                            "person_remove"
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          "\n                                                " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.removeUserFromRole"
                                                              )
                                                            ) +
                                                            "\n                                            "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a-sub-menu",
                                                      {
                                                        attrs: {
                                                          title:
                                                            _vm.$t(
                                                              "message.moveToRole"
                                                            ),
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.getOtherRoles(
                                                          groupKey
                                                        ),
                                                        function (r) {
                                                          return _c(
                                                            "a-menu-item",
                                                            {
                                                              key: r._id,
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.moveSingleUserToRole(
                                                                      user,
                                                                      groupKey,
                                                                      r._id
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    r.name
                                                                  ) +
                                                                  "\n                                                "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              }),
                              _vm._v(" "),
                              usersInGroup.length === 0
                                ? _c(
                                    "div",
                                    { staticClass: "role-card__empty" },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t("message.noUsersInRole")
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ],
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.showAddUserModal,
            title: _vm.$t("message.addUserToRole"),
            footer: null,
            width: 380,
          },
          on: { cancel: _vm.closeAddUserModal },
        },
        [
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                placeholder: _vm.$t("message.selectUser"),
                "show-search": "",
                "option-filter-prop": "children",
                loading: _vm.loadingUsers,
                "filter-option": _vm.filterOption,
              },
              model: {
                value: _vm.selectedUser,
                callback: function ($$v) {
                  _vm.selectedUser = $$v
                },
                expression: "selectedUser",
              },
            },
            _vm._l(_vm.availableUsers, function (user, index) {
              return _c(
                "a-select-option",
                { key: "add-user-" + index, attrs: { value: user._id } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        user.name || user.email || _vm.$t("message.unnamed")
                      ) +
                      "\n            "
                  ),
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-footer-actions" },
            [
              _c(
                "SupsisButton",
                { attrs: { ghost: "" }, on: { click: _vm.closeAddUserModal } },
                [_vm._v(_vm._s(_vm.$t("message.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "SupsisButton",
                {
                  attrs: { primary: "", disabled: _vm.addUserLoading },
                  on: { click: _vm.handleAddUser },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.save")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.showRemoveUserModal,
            title: _vm.$t("message.removeUserFromRole"),
            footer: null,
            width: 400,
          },
          on: { cancel: _vm.closeRemoveUserModal },
        },
        [
          _c(
            "div",
            { staticClass: "remove-user-modal-content" },
            [
              _c("p", [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.selectedUser &&
                        (_vm.selectedUser.name ||
                          _vm.selectedUser.email ||
                          _vm.$t("message.unnamed"))
                    )
                  ),
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.removeUserFromRoleConfirm")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "a-form-item",
                {
                  staticStyle: { "margin-top": "16px" },
                  attrs: { label: _vm.$t("message.selectNewRole") },
                },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("message.selectRole"),
                        "show-search": "",
                        "option-filter-prop": "children",
                        "filter-option": _vm.filterOption,
                      },
                      model: {
                        value: _vm.selectedNewRole,
                        callback: function ($$v) {
                          _vm.selectedNewRole = $$v
                        },
                        expression: "selectedNewRole",
                      },
                    },
                    _vm._l(_vm.roles, function (role, index) {
                      return _c(
                        "a-select-option",
                        {
                          key: "remove-role-" + index,
                          attrs: {
                            value: role._id,
                            disabled: role._id === _vm.selectedRoleId,
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(role.name) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-footer-actions" },
                [
                  _c(
                    "SupsisButton",
                    {
                      attrs: { ghost: "" },
                      on: { click: _vm.closeRemoveUserModal },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      attrs: { primary: "", disabled: _vm.removeUserLoading },
                      on: { click: _vm.handleRemoveUser },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("message.continue")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("message.bulkUpdateProgress"),
            visible: _vm.bulkProgress.visible,
            footer: null,
            closable: !_vm.bulkProgress.loading,
            maskClosable: false,
          },
        },
        [
          _c(
            "div",
            { staticClass: "progress-modal" },
            [
              _c("a-progress", {
                attrs: {
                  percent: _vm.bulkProgress.total
                    ? Math.round(
                        (_vm.bulkProgress.current / _vm.bulkProgress.total) *
                          100
                      )
                    : 0,
                  status: "active",
                },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "progress-modal__text" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.bulkProgress.current) +
                    " / " +
                    _vm._s(_vm.bulkProgress.total) +
                    " " +
                    _vm._s(_vm.$t("message.usersUpdated")) +
                    "\n            "
                ),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }